/** How long the highlight of a target stays, once the page has scrolled to it. */
export const DUREE_EVIDENCE_MS = 2000;

/** The attribute the highlight is carried by: the components style it with `data-[evidence=true]`. */
export const ATTRIBUT_EVIDENCE = 'data-evidence';

const minuteries = new WeakMap<Element, ReturnType<typeof setTimeout>>();

/** Someone who asked for less motion gets no smooth scrolling (the highlight is not a motion). */
export function mouvementReduit(): boolean {
  return typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;
}

/**
 * Takes the page to an element, highlights it for a moment and gives it the focus: the keyboard
 * and the screen readers go on from there (the element has a `tabIndex` and a name). The scroll is
 * smooth unless the user asked for reduced motion; `scroll-margin-top` of the element keeps it
 * clear of the top. The highlight is an `outline` (never a thicker border, never a background: the "À relire" mention is 3.9:1 on a tinted one), so
 * the element does not change its size.
 */
export function allerA(element: HTMLElement): void {
  element.scrollIntoView({
    behavior: mouvementReduit() ? 'auto' : 'smooth',
    block: 'start',
  });
  element.focus({ preventScroll: true });
  element.setAttribute(ATTRIBUT_EVIDENCE, 'true');
  clearTimeout(minuteries.get(element));
  minuteries.set(
    element,
    setTimeout(() => {
      element.removeAttribute(ATTRIBUT_EVIDENCE);
      minuteries.delete(element);
    }, DUREE_EVIDENCE_MS),
  );
}
